import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar, SidebarNav } from "./Sidebar";
import { Toaster } from "./ui/sonner";
import { GlobalSearch } from "./GlobalSearch";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Menu } from "lucide-react";
import { useAppStore } from "../store/useAppStore";
import { Brand } from "./Brand";
import { ReportProblemButton } from "./ReportProblemButton";

export function Layout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { planId } = useAppStore();

  return (
    <div className="flex min-h-dvh w-full overflow-hidden bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.08),_transparent_28%),linear-gradient(180deg,_#f8fafc_0%,_#f8fafc_42%,_#eef2ff_100%)] font-sans text-slate-900">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-20 flex-shrink-0 border-b border-slate-200/80 bg-white/85 px-4 py-3 shadow-sm shadow-slate-900/5 backdrop-blur sm:px-8">
          <div className="flex items-center gap-3 sm:hidden">
            <Sheet open={mobileNavOpen} onOpenChange={setMobileNavOpen}>
              <SheetTrigger
                render={
                  <Button variant="outline" size="icon" className="shrink-0 bg-white">
                    <Menu className="h-4 w-4" />
                  </Button>
                }
              />
              <SheetContent side="left" className="w-[84vw] max-w-sm border-slate-800 bg-slate-950 p-0 text-white">
                <div className="flex items-center gap-3 border-b border-white/10 p-6">
                  <Brand variant="logo" className="min-w-0" imageClassName="h-20 w-auto" />
                  <div>
                    <p className="font-semibold text-white">Navigate</p>
                  </div>
                </div>
                <SidebarNav
                  onNavigate={() => setMobileNavOpen(false)}
                  className="flex-1 space-y-1 overflow-y-auto px-4 py-4"
                  linkClassName="text-slate-200 hover:bg-white/8"
                />
                <div className="space-y-3 border-t border-white/10 p-4">
                  <div>
                    <p className="mb-1 text-xs font-semibold text-blue-300">{planId === "free" ? "FREE PLAN" : `${planId.toUpperCase()} PLAN`}</p>
                    <p className="text-sm text-slate-300">
                      {planId === "free"
                        ? "Limited access — upgrade to Foundation for AI follow-ups and more capacity."
                        : planId === "foundation"
                          ? "Foundation active — upgrade to Operator for more throughput."
                          : planId === "operator"
                            ? "Operator active — upgrade to Atlas for the deepest workflow."
                            : "Atlas active — the top workflow tier is enabled."}
                    </p>
                  </div>
                  <ReportProblemButton
                    buttonLabel="Report a problem"
                    triggerVariant="outline"
                    className="w-full justify-start border-slate-700 bg-slate-800 text-slate-100 hover:bg-slate-700 hover:text-white"
                  />
                </div>
              </SheetContent>
            </Sheet>
            <div className="min-w-0">
              <Brand variant="icon" className="items-center" />
              <h1 className="sr-only">Mobile navigation</h1>
            </div>
          </div>
          <div className="flex-1 sm:max-w-2xl">
            <GlobalSearch />
          </div>
        </header>
        <div className="relative min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-8">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </div>
  );
}
